let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("khxZX")).then(() => parcelRequire('3rcDX'));